export class DialogModelAddPickItem {
    constructor(
      public pickId: any
    ) {}
  }
  